import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import Dropdown from '@spa/shared/components/Dropdown';
import languageTranslations from '@spa/shared/constants/languageTranslations';
import { Container } from './styles';

const LanguageSelector = ({ onSelect = () => {}, changeLanguageByUrlHandler }) => {
  const { asPath, locale } = useRouter();
  const [key] = Object.entries(languageTranslations).find(([key]) => key.toLowerCase() === locale.toLowerCase());

  return (
    <Container>
      <Dropdown
        values={Object.entries(languageTranslations).map(([key, translation]) => ({
          ...(!changeLanguageByUrlHandler ? { link: asPath } : {}),
          key: key.toLocaleLowerCase(),
          locale: key.toLocaleLowerCase(),
          translation
        }))}
        selected={languageTranslations[key]}
        title={key}
        onSelect={onSelect}
      />
    </Container>
  );
};

LanguageSelector.propTypes = {
  onSelect: PropTypes.func,
  changeLanguageByUrlHandler: PropTypes.bool
};

export default LanguageSelector;
